import { render, staticRenderFns } from "./FIBFooter.vue?vue&type=template&id=1b453ab9&scoped=true&"
import script from "./FIBFooter.vue?vue&type=script&lang=js&"
export * from "./FIBFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b453ab9",
  null
  
)

export default component.exports